export default {
  setBlackLists(state, data) {
    state.blackLists = data;
  },
  
  setSaleManagerDiscountLimits(state, data) {
    state.saleManagerDiscountLimits = data;
  },

  setSaleManagerCredits(state, data) {
    state.saleManagerCredits = data;
  },

  setOrdrSettings(state, data) {
    state.ordrSettings = data || [];
  },

  setOrders(state, data) {
    state.orders = data;
  },
  setOrderById(state, data) {
    state.orderById = data;
  },
  setOrderMaxCode(state, data) {
    state.orderMaxCode = data;
  },

  setOrderCartable(state, data) {
    state.orderCartable = data;
  },

  setOrderManagementCartable(state, data) {
    state.orderManagementCartable = data;
  },

  setSettlementTypes(state, data) {
    state.settlementTypes = data;
  },

  setPrintLink(state, data) {
    state.printLink = data;
  },
};
